import { Box } from "@mui/material";

import { Banner, BannerList } from "~/components/design-system/index.js";

export function TokenRevoked({}: {}) {
  return (
    <Box data-testid="token-revoked">
      <Banner
        title="Token was revoked by Thalamos - please contact the Thalamos programme team to issue a new one"
        bannerType={BannerList.ERROR}
      />
    </Box>
  );
}
